export const LOCAL_STORAGE_IS_TESTNET_KEY = '__IS_TESTNET_KEY__'
export const LOCAL_STORAGE_ANNOUNCEMENTS_KEY = 'ANNOUNCEMENTS_KEY'
export const LOCAL_STORAGE_TERMS_OF_USE_KEY = '__TERMS_OF_USE_KEY__'
export const LOCAL_STORAGE_REFERRALS_TERMS_OF_USE_KEY = '__REFERRALS_TERMS_OF_USE_KEY__'
export const LOCAL_STORAGE_TRADER_SETTINGS_KEY = '__LOCAL_STORAGE_TRADE_SETTINGS_KEY__'
export const LOCAL_STORAGE_DEFAULT_NETWORK_KEY = '__DEFAULT_NETWORK__'
